import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import {Injectable} from '@angular/core';
import {environment} from '@environments/environment';
import {UserService} from '@core/user/user.service';
import {tryCatch} from 'rxjs/internal-compatibility';

@Injectable()
export class MyMonitoringService {
  appInsights: ApplicationInsights;

  constructor(private userService: UserService) {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.instrumentationKey,
        enableAutoRouteTracking: false // option to log all route changes
      }
    });
    this.appInsights.loadAppInsights();
  }

   logPageView(name?: string, url?: string, userData?: any) { // option to call manually

    this.appInsights.trackPageView({
      name,
      uri: url,
      properties: {
        userData
      }
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({name: name}, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({name: name, average: average}, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({exception: exception, severityLevel: severityLevel});
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({message: message}, properties);
  }
}
